'use client'

import { useEffect } from 'react'
import { GA_MEASUREMENT_ID, GOOGLE_ADS_ID } from '../../lib/analytics'

const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'touchstart', 'scroll', 'wheel']

export default function DeferredGtag() {
    useEffect(() => {
        window.dataLayer = window.dataLayer || []
        if (!window.gtag) {
            window.gtag = function gtag() { window.dataLayer.push(arguments) }
        }
        if (!window.__gtagConfigQueued) {
            window.__gtagConfigQueued = true
            window.gtag('js', new Date())
            window.gtag('config', GA_MEASUREMENT_ID)
            window.gtag('config', GOOGLE_ADS_ID)
        }

        let loaded = false
        function loadGtag() {
            if (loaded) return
            loaded = true
            INTERACTION_EVENTS.forEach(evt => window.removeEventListener(evt, loadGtag, true))
            const script = document.createElement('script')
            script.async = true
            script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
            document.head.appendChild(script)
        }

        INTERACTION_EVENTS.forEach(evt => window.addEventListener(evt, loadGtag, { passive: true, capture: true }))
        return () => INTERACTION_EVENTS.forEach(evt => window.removeEventListener(evt, loadGtag, true))
    }, [])

    return null
}
